import { Data, Menu, Utils } from 'common';
import filter from 'lodash/filter';
import uniqueId from 'lodash/uniqueId';

const { ItemType } = Menu;
const { InternalCapability } = Data;
const { Session } = Utils;

export class SettingsLeftMenuItems {
	/**
	 * Build settings left menu items.
	 */
	static build() {
		// menu items config
		const items = [
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'General Settings',
				visible: true,
				active: true,
				data: {
					navigationToken: 'generalSettings',
				},
				dataqa: 'settings-left-menu-general-settings',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Carriers',
				visible: true,
				active: false,
				data: {
					navigationToken: 'carrierSettings',
				},
				dataqa: 'settings-left-menu-carriers',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Manage Users',
				visible: true,
				active: false,
				data: {
					navigationToken: 'manageUsers',
				},
				dataqa: 'settings-left-menu-manage-users',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Ship From Address',
				visible: true,
				active: false,
				data: {
					navigationToken: 'shipFromAddress',
				},
				dataqa: 'settings-left-menu-ship-from-address',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Cost Codes',
				visible: Session.hasCapability(InternalCapability.EditCostCodes), // dependent on the appcap
				active: false,
				data: {
					navigationToken: 'costCodes',
				},
				dataqa: 'settings-left-menu-cost-codes',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Default Payment',
				visible: true,
				active: false,
				data: {
					navigationToken: 'defaultPayment',
				},
				dataqa: 'settings-left-menu-default-payment',
			},
			{
				id: parseInt(uniqueId(), 10),
				type: ItemType.Badge,
				title: 'Contact Information',
				visible: true,
				active: false,
				data: {
					navigationToken: 'contactInformation',
				},
				dataqa: 'settings-left-menu-contact-information',
			},
		];

		return filter(items, item => (item.visible === true ? item : null));
	}
}
